
export default {
  name: 'FieldHockeyIcon',
  props: {
    classCss: { type: String, default: '' },
  },
}
